import './ProjectsOverview.scss'

import React, {useEffect, useState} from 'react'
import {useLanguage, useTranslation} from '../../../util/i18n'

import {LoadingIcon} from '../../ui/LoadingIcon'
import {Overview} from '../Overview'
import {PageData} from '../../../types'
import {fetcher} from '../../../util/fetcher'
import qs from 'query-string'
import {style} from 'util/style'

const styles = style('projectsoverview')

type ProjectsOverviewType = {
	continent: string
	region: string
	themes: Array<string>
	projects: Array<ProjectType>
}

export type ProjectType = PageData

export const ProjectsOverview: React.FC<ProjectsOverviewType> = ({
	continent,
	region,
	themes,
	projects: projectTitles
}) => {
	const [projects, setProjects] = useState([])
	const [isLoaded, setLoaded] = useState(false)
	const t = useTranslation('impact').projects
	const lang = useLanguage()
	const hasProjects = projects?.length > 0
	const filterParams = qs.stringify(
		{
			continent,
			region,
			themes
		},
		{arrayFormat: 'bracket'}
	)

	useEffect(() => {
		setLoaded(false)
		fetcher(`/api/projects?${filterParams}`)
			.then((data: Array<PageData>) => {
				setLoaded(true)
				const translatedProjects = data.map((project) => {
					const title =
						projectTitles.find((projectTitle) => projectTitle.id === project.id)
							?.title || project.title
					let url = project.url
					if (lang !== 'nl') {
						url = project.url.replace('/nl/', `/${lang}/`)
					}
					return {...project, title, url}
				})
				setProjects(translatedProjects)
			})
			.catch(console.error)
	}, [filterParams])

	return (
		<div className={styles()}>
			{!isLoaded && (
				<div className={styles('loading')}>
					<LoadingIcon />
				</div>
			)}
			{hasProjects && isLoaded && (
				<Overview
					className={styles('overview')}
					container={false}
					layout="project"
					items={projects}
				/>
			)}
			{!hasProjects && isLoaded && (
				<div className={styles('empty')}>
					<p>{t.filter_empty}</p>
				</div>
			)}
		</div>
	)
}
